import React, { useState, useEffect, useRef, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { FaEdit, FaTrash,FaPen, FaCalculator  } from 'react-icons/fa';
import { BsFillSendFill } from "react-icons/bs";
import { Layout, Header, Modal,  DescriptionModal, CalculatorModal} from '../../../../components';
import { handleApi, formatCurrency, capitalize, inputDate,formatMediumDate,formatTwoDecimal,deepEqual } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditQuantityAdjustment = () => {
  const location = useLocation();
  const { quantity_adjustment } = location.state || {};
  console.log('quantity adjustment  form parent sir',location.state  )
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const emptyTransactionLine = {
    product_id: null,
    product_name: '',
    unit_of_measure: '',
    ordered_quantity: 0,
    adjusted_quantity: '',
  };
  
  const [quantityAdjustments, setQuantityAdjustments] = useState(() => {
    if (quantity_adjustment) {
      const lines = (quantity_adjustment.transactionLines || []).map(line => ({
        product_id: line.product_id || null,
        product_name: line.products?.name || '',
        unit_of_measure: line.prices?.sell_uom_name || '',
        ordered_quantity: line.old_quantity || 0,
        adjusted_quantity: line.new_quantity || '',
      }));
  
      return {
        id: quantity_adjustment.id,
        adjustment_date: quantity_adjustment.adjustment_date ?? new Date().toISOString(),
        description: quantity_adjustment.description || '',
        approved: quantity_adjustment.approved || 0,
        transactionLines: [...lines, emptyTransactionLine], // ✅ Always add one empty row
      };
    }
  
    return {
      id: 1,
      adjustment_date: new Date().toISOString(),
      description: '',
      approved: 0,
      transactionLines: [emptyTransactionLine], // ✅ Already one empty row for fresh record
    };
  });
  
  const [adjustmentReasons, setAdjustmentReasons] = useState([]);
  const [formattedAdjustmentReasons, setFormattedAdjustmentReasons] = useState([]);
  const [products, setProducts] = useState([]);
  const [formattedProducts, setFormattedProducts] = useState([]);
  const [adjusted, setDelivered] = useState([]);
  const [selectedAdjustmentId, setSelectedAdjustmentId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [editedLineIndex, setEditedLineIndex] = useState(null);
  const [selectedLineIndex, setSelectedLineIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
  const [openAdjustmentId, setOpenAdjustmentId] = useState(null);
  const [editingDescriptionId, setEditingDescriptionId] = useState(null);
  const [editedDescription, setEditedDescription] = useState('');

  const navigate = useNavigate();
  const quantityRefs = useRef([]);
  const productRefs=useRef([]);
  // const dateInputRef = useRef(null);
  const datePickerRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    setSelectedAdjustmentId(quantity_adjustment.id);

    const fetchData = async () => {
      try {
        // Fetch both products and suppliers in parallel using Promise.all
        const [productsResponse, suppliersResponse] = await Promise.all([
          fetchProducts(),
          fetchAdjustmentReasons()
        ]);
      } catch (error) {console.error('Error fetching data:', error);}
    };
    fetchData();
  }, []); // Empty dependency array ensures this runs only once when the component mounts
  

  useEffect(() => {
    const handleClickOutside=(event)=> {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setOpenAdjustmentId(null); // Close the date picker
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {document.removeEventListener("mousedown", handleClickOutside);};
  }, []);

  const fetchProducts = async () => {
    const apiEndpoint = 'products';
    const apiMethod = 'GET';
    const cleanedData = {};
    const parameters = {};
    try {
      const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
      if (response.error) {
        console.error(`Error fetching products: ${response.errorMessage}`);
        return;
      }
      const { status, data } = response;
      if (status === 200) {
        setProducts(data);
        const formattedproducts = data.map((product) => ({
          value: product.id,
          label: product.name,
          old_quantity: product.quantity_instock || 0,
          unit_of_measure: product?.prices?.buy_uom_name || '',
        }));
        setFormattedProducts(formattedproducts);
      } else {toast.error(`Error ${status}: ${response.statusText}`);}
    } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
  };
    
  const fetchAdjustmentReasons = async () => {
    const apiEndpoint = 'quantity_adjustment_reasons';
    const apiMethod = 'GET';
    const cleanedData = {};
    const parameters = {};

    try {
      const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
      if (response.error) {
        console.error(`Error fetching suppliers: ${response.errorMessage}`);
        return;
      }
      const { status, data } = response;
      if (status === 200) {
        const formattedReasons = data.map(reason => ({
          value: reason.id,
          label: reason.name
        }));
        setFormattedAdjustmentReasons(formattedReasons);
        setAdjustmentReasons(data);
      } else {toast.error(`Error ${status}: ${response.statusText}`);}
    } catch (error) { toast.error(error.message || 'An unexpected error occurred.');}
  };
  
  const handleAdjustmentReasonChange = (id,newDescription) => {
    setQuantityAdjustments(prev => ({
      ...prev,
      description: newDescription,
    }));
  };
  const handleOpenCalculator = (index) => {
    setEditedLineIndex(index);
    setIsCalculatorOpen(true);
    setIsModalOpen(true); // Ensure the main modal is opened too 
  };
    
  // const handleSaveCalculatedQuantity = (calculatedQuantity) => {
  //   const updatedTransactionLines = [...adjustment.transactionLines];
  //   updatedTransactionLines[selectedLineIndex].quantity = calculatedQuantity;
  //   updatedTransactionLines[selectedLineIndex].total = (updatedTransactionLines[selectedLineIndex].unit_price * calculatedQuantity) * (1 - updatedTransactionLines[selectedLineIndex].discount_percentage / 100);
  //   setQuantityAdjustments({ ...adjustment, transactionLines: updatedTransactionLines });
  //   setIsModalOpen(false);
  // };
    
  const handleDateChange = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
    setQuantityAdjustments((prev) => ({ ...prev,adjustment_date: formattedDate,}));
  };
    
  const handleTransactionLineChange = (index, change) => {
    setQuantityAdjustments((prevAdjustment) => {
      const updatedTransactionLines = [...prevAdjustment.transactionLines];
  
      // Handle product selection (if `change` is an object with `.value`)
      if (change?.value !== undefined) {
        const isDuplicate = updatedTransactionLines.some(
          (line, i) => line.product_id === change.value && i !== index
        );
  
        if (isDuplicate) {
          const duplicateIndex = updatedTransactionLines.findIndex(
            (line, i) => line.product_id === change.value && i !== index
          );
  
          setTimeout(() => {
            if (quantityRefs.current[duplicateIndex]) {
              quantityRefs.current[duplicateIndex].focus();
              quantityRefs.current[duplicateIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 100);
  
          return prevAdjustment; // No change due to duplicate
        }
  
        const updatedLine = { ...updatedTransactionLines[index] };
        updatedLine.product_id = change.value;
        updatedLine.product_name = change.label;
        updatedLine.unit_of_measure = change.unit_of_measure;
        updatedLine.ordered_quantity = change.old_quantity;
        updatedLine.adjusted_quantity = ''; // ✅ Reset when product changes
        updatedTransactionLines[index] = updatedLine;
        // ✅ Focus adjusted_quantity input after selecting product
        setTimeout(() => {
          if (quantityRefs.current[index]) {quantityRefs.current[index].focus();}
        }, 0);
        return {...prevAdjustment,transactionLines: updatedTransactionLines,};
      }
  
      // Handle quantity input
      if (typeof change === "string" || typeof change === "number") {
        const numericValue = parseFloat(change);
        if (!isNaN(numericValue)) {
          const updatedLine = { ...updatedTransactionLines[index] };
          updatedLine.adjusted_quantity = numericValue;
  
          const isLastLine = index === updatedTransactionLines.length - 1;
          if (isLastLine && numericValue > 0) {
            updatedTransactionLines.push({
              product_id: null,
              product_name: '',
              unit_of_measure: '',
              ordered_quantity: 0,
              adjusted_quantity: '',
            });
          }
  
          updatedTransactionLines[index] = updatedLine;
        }
  
        return {
          ...prevAdjustment,
          transactionLines: updatedTransactionLines,
        };
      }
  
      return prevAdjustment; // fallback
    });
  };
    
  const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => { // Timeout helper for API calls
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {toast.error('Request timed out');
      } else {toast.error('Error: ' + error.message); }
      throw error;
    } finally {clearTimeout(timeoutId);}
  };
  
  const handleSubmit = async (e, c) => {
    if (e && e.preventDefault) { e.preventDefault(); }
    const selectedQuantityAdjustment = quantityAdjustments;
    const cleanedTransactionLines = selectedQuantityAdjustment.transactionLines
      .filter(line => line.adjusted_quantity != null && line.adjusted_quantity !== '')
      .map(line => ({
        new_quantity: line.adjusted_quantity,
        product_id: line.product_id,
      }));
  
    const cleanedAdjustment = {
      id:selectedQuantityAdjustment.id,
      adjustment_date: format(new Date(selectedQuantityAdjustment.adjustment_date), 'yyyy-MM-dd'),
      description: selectedQuantityAdjustment.description,
      approved: 0,
      transactionLines: cleanedTransactionLines,
    };
    console.log('clean adjustment sir',cleanedAdjustment)
    const apiMethod = 'PUT';
    const parameters = {id:quantityAdjustments.d};
    setIsLoading(true);
  
    try {
      const response = await handleApi(
        'quantity_adjustments',
        cleanedAdjustment,
        userData,
        apiMethod,
        parameters
      );
  
      if (response.status === 200) {toast.success('Quantity updated successfully.');
      } else {toast.error('Error saving Quantity.', response.statusText);}
    } catch (error) {toast.error('Error saving Quantity: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };
   
  const handleClose = () => { navigate(-1);   }; // Navigate back when closing the form
  console.log('quantityAdjustments at this point',quantityAdjustments)
  return (
    <Layout>
      {/* <div className="m-4 bg-gray-900 rounded-2xl shadow-xl p-6"> */}
      <div className=" bg-gray-800 rounded-xl shadow-2xl p-2">
        <ToastContainer position="top-center" autoClose={2000} />
        <div className="text-center py-4 border-b border-gray-700">
          <div className="w-full flex justify-end">
            <button
              className="text-white hover:text-gray-400 py-1 px-2 rounded-full transition-all duration-300"
              title="Close"
              onClick={handleClose}
            >
              <MdOutlineCancel size={24} color={currentColor} />
            </button>
          </div>
          <div className="mx-4 text-white">
            <Header category="Inventory" title="Edit Quantity Adjustment" color={currentColor} />
          </div>
        </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" color="white" ariaLabel="loading" />
            <p className="mt-4 text-white text-sm">Processing quantity_adjustment...</p>
          </div>
        ) : (
          // <div className="bg-gray-800 p-6 my-4 rounded-2xl shadow-xl max-w-full mx-auto">
          <div className="bg-white p-2 my-4 rounded-xl shadow-2xl">
            <div className="space-y-6">
              <div
                key={quantityAdjustments.id}
                className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-5 shadow-xl hover:shadow-2xl transition-all duration-300 max-w-lg mx-auto border border-gray-700"
              >
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                  {/* Adjustment ID & Status */}
                  <div className="flex-1 text-center md:text-left">
                    <div className="flex flex-wrap items-center justify-center md:justify-start gap-2">
                      <p className="text-sm font-semibold text-gray-300 tracking-wide">
                        Adjustment <span className="text-blue-400 font-bold">#{quantityAdjustments.id}</span>
                      </p>
                      <span
                        className={`px-3 py-1 text-xs font-semibold rounded-full shadow-md transition 
                          ${
                            quantityAdjustments.approved === 0
                              ? 'bg-yellow-500 text-black'
                              : quantityAdjustments.approved === 1
                              ? 'bg-green-500 text-white'
                              : 'bg-gray-500 text-white'
                          }`}
                      >
                        {quantityAdjustments.approved === 0
                          ? 'In Draft'
                          : quantityAdjustments.approved === 1
                          ? 'Approved'
                          : 'Unknown'}
                      </span>
                    </div>
                  </div>

                  {/* Date Picker Toggle */}
                  <div className="relative flex-1 text-center">
                    <button
                      onClick={() =>
                        setOpenAdjustmentId(quantityAdjustments.id) }
                      className="text-xs text-gray-400 hover:text-blue-400 transition flex flex-col items-center"
                    >
                      {quantityAdjustments.adjustment_date && !isNaN(new Date(quantityAdjustments.adjustment_date).getTime()) ? (
                        <>
                          <span className="font-medium">
                            {format(new Date(quantityAdjustments.adjustment_date), 'MMM d')}
                          </span>
                          <span className="text-xs text-gray-500">
                            {format(new Date(quantityAdjustments.adjustment_date), 'yyyy')}
                          </span>
                        </>
                      ) : ( <span className="text-red-500 text-xs">Invalid date</span>
                      )}
                     </button>

                    {openAdjustmentId === quantityAdjustments.id && (
                      <div
                        ref={datePickerRef}
                        className="absolute z-50 mt-2 left-1/2 -translate-x-1/2 bg-white shadow-2xl rounded-xl border border-gray-300"
                      >
                        <DatePicker
                          selected={new Date(quantityAdjustments.adjustment_date)}
                          onChange={(date) => {
                            handleDateChange(date, quantityAdjustments.id);
                            setOpenAdjustmentId(null);
                          }}
                          inline
                          showYearDropdown
                          showMonthDropdown
                          yearDropdownItemNumber={100}
                          dateFormat="MMMM d, yyyy"
                          minDate={new Date(2020, 0, 1)}
                          maxDate={new Date()}
                          className="bg-white text-sm"
                        />
                      </div>
                    )}
                  </div>

                  {/* Toggle Button */}
                  <div
                    onClick={() =>setSelectedAdjustmentId(quantityAdjustments.id)}
                    className={`w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center cursor-pointer transition-transform duration-300 ${
                      selectedAdjustmentId === quantityAdjustments.id ? 'rotate-45' : ''
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  </div>
                </div>

                {/* Reason for Adjustment */}
                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Reason for Adjustment
                  </label>
                  {editingDescriptionId === quantityAdjustments.id ? (
                    <Select
                      options={formattedAdjustmentReasons}
                      value={formattedAdjustmentReasons.find(option => option.label === quantityAdjustments.description)}
                      onChange={(selectedOption) => {
                        handleAdjustmentReasonChange(quantityAdjustments.id, selectedOption.label);
                        setEditingDescriptionId(null);
                      }}
                      onBlur={() => setEditingDescriptionId(null)}
                      placeholder="Select Reason"
                      autoFocus
                      className="text-gray-800"
                      classNamePrefix="react-select"
                      styles={{
                        control: (base) => ({
                ...base,
                backgroundColor: '#1f2937',
                borderColor: '#3b82f6',
                color: 'white',
              }),
              singleValue: (base) => ({...base,color: 'white',}),
              menu: (base) => ({
                ...base,
                backgroundColor: '#111827',
                color: 'white',
              }),
              option: (base, { isFocused }) => ({
                ...base,
                backgroundColor: isFocused ? '#3b82f6' : '#111827',
                color: 'white',
              }),
            }}
          />
        ) : (
          <em
            onClick={() => {
              setEditingDescriptionId(quantityAdjustments.id);
              setEditedDescription(quantityAdjustments.description || '');
            }}
            className="italic text-gray-400 hover:text-blue-400 cursor-pointer transition"
          >
           {String(quantityAdjustments.description || '').trim() || 'Click to select a reason...'}
            {/* {quantityAdjustments.description?.trim() || 'Click to select a reason...'} */}
          </em>
        )}
      </div>
    </div>
  </div>

{/* Delivered Transaction Lines (Display Items and Allow Data Input) */}
{selectedAdjustmentId === quantityAdjustments.id && (
  <div className="my-2 p-2 bg-gray-700 rounded-lg transition-all duration-300 max-w-fit mx-auto">
    {/* Table Header */}
    <div className="grid grid-cols-[minmax(200px,1fr)_80px_120px_90px] gap-4 text-sm p-4 border-b text-gray-300 font-semibold">
      <div className="text-left">Product</div>
      <div className="text-center">Uom</div>
      <div className="text-center">Original Qty</div>
      <div className="text-center">Adjusted Qty</div>
    </div>

    {/* Table Content */}
    {quantityAdjustments.transactionLines.length > 0 ? (
      quantityAdjustments.transactionLines.map((line, index) => (
        <div
          key={index}
          className="grid grid-cols-[minmax(200px,1fr)_80px_120px_90px] gap-4 px-4 border-b bg-gray-800 hover:bg-gray-700 text-sm transition-all duration-200"
        >
          <Select
            ref={el => (productRefs.current[index] = el)}
            name="product_name"
            options={formattedProducts}
            value={line.product_id ? { value: line.product_id, label: line.product_name } : null}
            onChange={opt => handleTransactionLineChange(index, opt)}
            placeholder="Select Product"
            className="w-full text-left text-gray-700 focus:ring-2 focus:ring-blue-300"
            classNamePrefix="react-select"
          />
          <div className="text-center mt-2 text-gray-300">{line.unit_of_measure}</div>
          <div className="text-center text-gray-300 mt-2">{Math.round(line.ordered_quantity)}</div>
          <div className="relative">
            <input
              name="adjusted_quantity"
              ref={el => (quantityRefs.current[index] = el)}
              value={line.adjusted_quantity}
              onChange={e => handleTransactionLineChange(index, e.target.value)}
              className="w-full text-center text-gray-700 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-300"
              placeholder="0"
            />
            <button
              type="button"
              className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500 hover:text-blue-600"
              title="Calculate quantity"
              onClick={() => handleOpenCalculator(index)}
              disabled={!line.product_id}
            >
              <FaCalculator size={14} />
            </button>
          </div>
        </div>
      ))
    ) : (
      <div className="text-center text-gray-500 py-4">No order details found</div>
    )}
  </div>
)}
            {/* Action Buttons */}
            <div className="flex justify-center space-x-6 mt-6">
              <button
                onClick={handleSubmit}
                className="bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition-all duration-300 flex items-center gap-2"
              >
                <BsFillSendFill size={20} />
                <span>Submit</span>
              </button>

              <button
                onClick={handleClose}
                className="bg-blue-500 text-white px-6 py-3 rounded-xl hover:bg-blue-600 transition-all duration-300 flex items-center gap-2"
              >
                <MdOutlineCancel size={20} />
                <span>Close</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modal for Calculator */}
      <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} minWidth="90%">
        {isCalculatorOpen && (
          <CalculatorModal
            isOpen={isCalculatorOpen}
            onClose={() => setIsCalculatorOpen(false)}
          // onSave={handleSaveCalculatedQuantity}
            defaultQuantity={quantityAdjustments.transactionLines[selectedLineIndex]?.quantity}
          />
        )}
      </Modal>
    </Layout>
  );
};
export default EditQuantityAdjustment;
